export default {
  error_msg: (state) => state.error_msg,
  errors: (state) => state.errors,
  success: (state) => state.success,
  governorates: (state) => state.governorates,
  cities: (state) => state.cities,
  stationList: (state) => state.stationList,
  hoodsList: (state) => state.hoodsList,
  coopsList: (state) => state.coopsList,
  diseases: (state) => state.diseases,
  medicines: (state) => state.medicines,
};
